import React, { Component } from 'react'
import DashboardCard from './dashboardCard';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';

import AddIcon from 'material-ui/svg-icons/content/add-circle';
import ListIcon from 'material-ui/svg-icons/action/list';
import FolderIcon from 'material-ui/svg-icons/file/folder';
import EyeIcon from 'material-ui/svg-icons/image/remove-red-eye';
import ClockIcon from 'material-ui/svg-icons/device/access-time';
import WarantyIcon from 'material-ui/svg-icons/action/verified-user';
import MoneyIcon from 'material-ui/svg-icons/editor/monetization-on';
import RBVLogoImage from 'file-loader!../images/Remorque_Belle_Voiture_Logo204.png'
import LogoImage from 'file-loader!../images/Velox_Logo_Login.png'

const Styles = {
  Container: {
    width: '100%',   
  },
  MenuItemsContainer: {
    display: 'table',    
    margin: '0 auto'
  },
  MenuLine: {
    display: 'flex', 
  },
  Icon: {
    width: 48,
    height: 48
  }
};

class Dashboard extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      currentUserName: '',
      currentDate: null
    };
  }

  componentDidMount(){
    var utils = require('../misc/utils');
    utils.default.fetchCurrentUser((user) =>{
      if(user){
        this.setState({
          currentUserName: user.Name,
          currentDate: new Date().toLocaleDateString('fr-CA', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'})
        });
      }
    });
  }  

  render() {    
    return (
      <div style={Styles.Container}>
        <div>
          <table style={{width: '100%'}}>
            <colgroup>
              <col style={{width: '50%'}} />
              <col style={{width: '50%'}} />
            </colgroup>             
            <tbody>
              <tr>
                <td><h2>Tableau de bord</h2></td>
                <td style={{textAlign: 'right'}}><h3>{this.state.currentDate}</h3></td>
              </tr>
            </tbody>
          </table>
        </div> 
        <Divider/>
        <div> 
          <table>
            <tbody>
              <tr>
                <td><img src={RBVLogoImage} style={{marginLeft: '50px', marginTop: '20px', marginBottom: '20px'}}/></td>
                <td><h2 style={{marginLeft: '50px'}}>Bienvenue {this.state.currentUserName}!</h2></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={Styles.MenuItemsContainer}>
          <h2>Inventaire</h2>
          <div style={Styles.MenuLine}>            
            <DashboardCard title='Ajouter' apiRoute='/trailers?isNew=true' icon={<AddIcon style={Styles.Icon} />} />
            <DashboardCard title='Actives' apiRoute='/trailers' icon={<ListIcon style={Styles.Icon} />} />
            <DashboardCard title='Archives' apiRoute='/trailersinactive' icon={<FolderIcon style={Styles.Icon} />} />
          </div>
          <h2>Soumissions</h2>
          <div style={Styles.MenuLine}>
            <DashboardCard title='Ajouter' apiRoute='/quotes?isNew=true' icon={<AddIcon style={Styles.Icon} />} />
            <DashboardCard title='En cours' apiRoute='/quotes' icon={<EyeIcon style={Styles.Icon} />} />
            <DashboardCard title='Archives' apiRoute='/quotesinactive' icon={<FolderIcon style={Styles.Icon} />} />
          </div>
          <h2>Paramètres</h2>          
          <div style={Styles.MenuLine}>
            <DashboardCard title="Heures d'ouverture" apiRoute='/openhours' icon={<ClockIcon style={Styles.Icon} />} />
            <DashboardCard title='Garanties' apiRoute='/waranties' icon={<WarantyIcon style={Styles.Icon} />} />
            <DashboardCard title='Calculateur de prêts' apiRoute='/loansetting' icon={<MoneyIcon style={Styles.Icon} />} />
          </div>          
        </div>
        <div style={{textAlign: 'right', marginRight: '20px', marginTop: '50px'}}>
          <img src={LogoImage} style={{opacity: 0.2, height: '75px'}}/>
        </div>     
      </div>
    )
  }
}

export default Dashboard;


/** WEBPACK FOOTER **
 ** ./src/app/components/dashboard.js
 **/